import autosize from 'autosize';

export default function(rootEl) {
  // add active class
  const handleFocus = e => {
    const target = e.target;
    target.parentNode.classList.add('active');
    target.parentNode.classList.add('focus');
  };

  // remove active class
  const handleBlur = e => {
    const target = e.target;
    target.parentNode.classList.remove('focus');
    if (!target.value && !target.getAttribute('placeholder')) {
      target.parentNode.classList.remove('active');
    }
  };

  // register events
  const bindEvents = element => {
    const floatField = element.querySelector('.form-control');
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);
  };

  if (!rootEl) {
    rootEl = document;
  }

  // get DOM elements
  const floatContainers = rootEl.querySelectorAll(
    '.c-form__floatinglabels .form-group.shortanswer, .c-form__floatinglabels .form-group.longanswer, .c-form__floatinglabels .form-group.password, .c-form__floatinglabels .form-group.dropdown, .c-form__floatinglabels .form-group.date, .c-form__floatinglabels .form-group.fileupload'
  );

  for (var i = 0, len = floatContainers.length; i < len; i++) {
    const el = floatContainers[i];
    if (el.querySelector('.form-control').value) {
      el.classList.add('active');
    } else if (el.querySelector('.form-control').getAttribute('placeholder')) {
      el.classList.add('active');
    }

    bindEvents(floatContainers[i]);
  }

  autosize(rootEl.querySelectorAll('textarea.form-control'));
}
